import { SYNC_TOAST_STATE } from '../mutation-types';

// init state
const state = {
  user: {},
  /* 右侧组件显示数组 默认标题组件永远显示 */
  setComponentsItems: [{'component': 'setPageTitle', 'index': 0, 'fixed': true}],
  /* 左侧组件显示数组 */
  getComponentsItems: [],
  showLoading: false,
  loadingLabel: '加载中...',
  showToast: false,
  toastLabel: '操作成功',
  // 获取的页面数据
  pageData: {},
  /* 咨询导图 以及衍生的悬浮框*/
  consult: [{
    consultFont: '在线咨询',
    consultColor: '#118ee9',
    isMajorColor: '1',
    right: '35px',
    top: '5px',
    hrefUrl: '',
    width: '',
    height: '',
    radius: ''
  }],
  /* 预览屏幕 1 移动端 、2 PC 端 */
  radioPreview: 1,
  sideMenuName: 'workPlace',
  breadName1: {id: '', name: ''},
  breadName2: {id: '', name: ''}
};

const mutations = {
  /* 用户信息 */
  newUser (state, msg) {
    state.user = msg;
  },
  /* 禁止浏览器回退 */
  newForbidHistory (state, msg) {
    state.forbidHistory = msg;
  },
  /* 右侧组件数组 */
  newSetComponentsItems (state, msg) {
    state.setComponentsItems = msg;
  },
  /* 左侧组件数组 */
  newGetComponentsItems (state, msg) {
    state.getComponentsItems = msg;
  },
  [SYNC_TOAST_STATE] (state, {showToast, toastLabel}) {
    state.showToast = showToast;
    state.toastLabel = toastLabel;
  },
  // 更新页面数据
  newPageData (state, msg) {
    state.pageData = msg;
  },
  newConsult(state, msg) {
    state.consult = msg;
  },
  /* 预览屏幕 1 移动端 、2 PC 端 */
  newRadioPreview(state, msg) {
    state.radioPreview = msg;
  },
  newSideMenuName(state, msg) {
    state.sideMenuName = msg;
  },
  newBreadName1(state, msg) {
    state.breadName1 = msg;
  },
  newBreadName2(state, msg) {
    state.breadName2 = msg;
  },
};

export default {
  state,
  mutations
};



// WEBPACK FOOTER //
// ./src/vuex/modules/app.js